var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"content",attrs:{"tag":"ul","name":"fade-list"}},_vm._l((_vm.list),function(item){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],key:item.code},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d605fbda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TransitionText.vue
// module id = null
// module chunks = 